import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Sets a native tooltip with the full text only when the host is truncated
 * (ellipsis / overflow).
 */
@Directive({
  selector: '[libEllipsisTooltip]',
  standalone: true,
})
export class EllipsisTooltipDirective {
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const node = this.el.nativeElement;
    const truncated =
      node.scrollWidth > node.clientWidth + 1 ||
      node.scrollHeight > node.clientHeight + 1;
    const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    if (truncated && text) {
      node.setAttribute('title', text);
    } else {
      node.removeAttribute('title');
    }
  }
}
